export const config = {
  // NOTE:
  // Since during the build process we don't include our local .env file, all the env variables
  // will be "{}.VITE_XXX", we then use a script in our deployment to replace those variables
  // at runtime with environment variables in kubernetes

  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT ?? '{}.VITE_ENVIRONMENT',
  BACKEND_URL: import.meta.env.VITE_BACKEND_URL ?? '{}.VITE_BACKEND_URL',

  // Keycloak Authentication
  KEYCLOAK_URL: import.meta.env.VITE_KEYCLOAK_URL ?? '{}.VITE_KEYCLOAK_URL',
  KEYCLOAK_REALM: import.meta.env.VITE_KEYCLOAK_REALM ?? '{}.VITE_KEYCLOAK_REALM',
  KEYCLOAK_CLIENT_ID: import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? '{}.VITE_KEYCLOAK_CLIENT_ID',

  // SSO
  SSO_COOKIE_DOMAIN: import.meta.env.VITE_SSO_COOKIE_DOMAIN ?? '{}.VITE_SSO_COOKIE_DOMAIN',

  // Legacy Supabase (to be removed after migration)
  SUPABASE_PROJECT_ID: import.meta.env.VITE_SUPABASE_PROJECT_ID ?? '{}.VITE_SUPABASE_PROJECT_ID',
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL ?? '{}.VITE_SUPABASE_URL',
  SUPABASE_PUBLISHABLE_KEY:
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? '{}.VITE_SUPABASE_PUBLISHABLE_KEY',

  // Analytics
  GA_TRACKING_ID: import.meta.env.VITE_GA_TRACKING_ID ?? '{}.VITE_GA_TRACKING_ID',
};
